<template>
    <div :class="[
        'icons-tile',
        {
            'icons-tile--active': active,
            'icons-tile--no-hover': noHover,
        }
    ]"
    >
        <router-link :title="slotTitle"
            :to="url"
            :class="[
                'icons-tile__top',
                {
                    'icons-tile__top--no-action' : !actionTitle.length,
                    'icons-tile__top--disabled': disabled,
                }
            ]"
        >
            <div v-if="!active && actionTitle.length"
                :class="['icons-tile__overlay', { 'icons-tile__overlay--no-hover': noHover }]"
            />

            <div class="icons-tile__icons">
                <i :class="`icon icon-${icon}`" />
                <i :class="`status icon-${setStatus(status)}`" />
            </div>

            <div class="icons-tile__text">
                <slot />
            </div>
        </router-link>

        <div v-if="actionTitle.length"
            class="icons-tile__bottom"
            @click="$emit('actionClick');"
        >
            {{ actionTitle }}
        </div>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

// Types
import {
    KycExpiration,
} from '@shared/types/kyc';

export default {
    name: 'icons-tile',
    props: {
        url: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: 'empty',
        },
        title: {
            type: String,
            default: '',
        },
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        noHover: {
            type: Boolean,
            default: false,
        },
        actionTitle: {
            type: String,
            default: '',
        },
        slotTitle: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapGetters(['userId']),
    },
    methods: {
        setStatus(status) {
            switch (status) {
                case KycExpiration.Expiring:
                    return 'alert-circle expiring';
                case KycExpiration.Expired:
                    return 'alert-circle expired';
                case 'processing':
                    return 'processing';
                case 'validated':
                case 'complete':
                    return 'done';
                default:
                    return 'empty';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.icons-tile {
    width: 25.7rem;
    border-radius: 1rem;
    color: $cyprus-color;
    position: relative;
    overflow: hidden;
    margin-bottom: 1rem;

    * {
        cursor: pointer;
    }

    &:hover:not(&--no-hover) {
        box-shadow: 0 0.3rem 1rem rgba($black-color, 0.15);
    }

    &:first-child {
        margin-left: 2rem;
    }

    &--no-hover {
        box-shadow: 0 0.3rem 1rem rgba($black-color, 0.15);
    }

    &--active {
        &:not(.icons-tile--no-hover) {
            box-shadow: none;

            &:hover {
                box-shadow: none;
            }
        }

        a {
            border-bottom: 0.2rem solid $cyprus-color;
        }

        .icons-tile__top {
            &--no-action {
                background: $porcelain-dark-color;
            }
        }
    }

    &__top {
        height: 11.5rem;
        box-sizing: border-box;
        padding: 2.1rem 3.4rem;
        background: $white-color;
        display: flex;
        position: relative;
        text-decoration: none;
        color: $cyprus-color;

        &--no-action {
            height: 16.9rem;
            border: none !important;

            &:hover {
                background: $porcelain-dark-color;
            }
        }

        &--disabled {
            pointer-events: none;
            opacity: 0.5;
        }
    }

    &__overlay {
        cursor: pointer;
        opacity: 0;
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($cyprus-color, 0.8);

        &:hover {
            cursor: pointer;

            &--no-hover {
                opacity: 0;
            }
        }
    }

    &__text {
        padding-left: 2.5rem;
    }

    &__icons {
        position: relative;
        height: fit-content;

        .icon {
            font-size: 5rem;
        }

        .status {
            position: absolute;
            font-size: 3rem;
            right: -1rem;
            bottom: -1rem;
            background: $white-color;
            border-radius: 100%;
        }
    }

    &__bottom {
        font-size: 1.2rem;
        line-height: 4.9rem;
        text-align: center;
        background: linear-gradient(180deg, $alto-color 0%, $porcelain-dark-color 20%);

        &:hover {
            cursor: pointer;
            color: $white-color;
            background: rgba($cyprus-color, 0.8);
        }
    }
}

.icon-done {
    color: $lima-color;
}

.icon-processing {
    color: $buttercup-color;
}

.expiring {
    color: $orange-peel-color;
}

.expired {
    color: $torch-red-color;
}
</style>